// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"b694f197","806":"49887fa4"}[chunkId] + ".chunk.js";
};